import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Button } from 'reactstrap';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      background: 'rgba(255, 255, 255, 0.95)',
      backdropFilter: 'blur(10px)',
      borderTop: '1px solid rgba(102, 126, 234, 0.2)',
      padding: '20px 0',
      zIndex: 1000,
      boxShadow: '0 -4px 20px rgba(0, 0, 0, 0.1)'
    }}>
      <Container>
        <Row className="align-items-center">
          <Col md="8">
            <p style={{
              color: '#333',
              fontSize: '0.95rem',
              margin: 0,
              lineHeight: '1.5'
            }}>
              🍪 We use cookies to enhance your browsing experience, serve personalized content, and analyze our traffic. 
              By clicking "Accept All", you consent to our use of cookies. 
              <a href="/privacy" style={{ color: '#667eea', textDecoration: 'none' }}>
                Learn more
              </a>
            </p>
          </Col>
          <Col md="4" className="text-md-right mt-3 mt-md-0">
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end', flexWrap: 'wrap' }}>
              <Button
                onClick={declineCookies}
                style={{
                  background: 'transparent',
                  border: '1px solid #ccc',
                  color: '#666',
                  padding: '8px 20px',
                  borderRadius: '20px',
                  fontSize: '0.9rem',
                  fontWeight: '500'
                }}
              >
                Decline
              </Button>
              <Button
                onClick={acceptCookies}
                className="btn-round"
                style={{
                  background: 'linear-gradient(45deg, #667eea, #764ba2)',
                  border: 'none',
                  padding: '8px 20px',
                  borderRadius: '20px',
                  color: 'white',
                  fontSize: '0.9rem',
                  fontWeight: '500'
                }}
              >
                Accept All
              </Button>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default CookieConsent;
